const ITEMS = ["TRAP", "R&B", "DRILL", "MELODIC", "WEST COAST", "CUSTOM PRODUCTION", "MIXING & MASTERING", "VIDEOGRAPHY"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#0B0B0E] py-5">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-heading px-8 text-2xl font-extrabold uppercase tracking-tight text-zinc-700 sm:text-3xl">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-300" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
